<template>
  <TIcon name="loader" class="inline h-4 w-4 animate-spin text-neutral-400" />
</template>
